import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface CreateMutationProps<PayloadType, ResponseType> {
  queryKey: unknown[];
  apiFunction: (payload: PayloadType) => Promise<ResponseType>;
  onSuccess?: (response: ResponseType) => void;
  onError?: (error: AxiosError) => void;
}

export const useCreateMutation = <PayloadType, ResponseType>({
  queryKey,
  apiFunction,
  onSuccess,
  onError,
}: CreateMutationProps<PayloadType, ResponseType>): UseMutationResult<
  ResponseType,
  AxiosError,
  PayloadType,
  unknown
> => {
  return useMutation<ResponseType, AxiosError, PayloadType, unknown>(
    queryKey,
    (payload: PayloadType) => apiFunction(payload),
    { onSuccess, onError },
  );
};
